import { Component, OnInit } from '@angular/core';
declare let jQuery: any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  minHeight: number;
  constructor() { }

  ngOnInit() { 
    this.minHeight = window.innerHeight - jQuery('footer.marketing-footer').outerHeight();
  }

}
